<template>
  <div class="">
    <select-dict v-model="shippingState" :select-list="states" :disabled="disabled" />
    <p class="hint-message" v-if="needHintMessage">Contact the estimator</p>
  </div>
</template>

<script setup lang="ts">
import { computed, defineModel, watch } from "vue";

import SelectDict from "@/components/UI/SelectDict.vue";

import { useNewEstimateStore } from "@/stores/new/estimateStore";
import { useDictStore } from "@/stores/dictStore";

const dictStore = useDictStore();
const estimateStore = useNewEstimateStore();

const shippingState = defineModel<string>("state", { default: "" });
const disabled = defineModel("disabled", { default: false });

const states = dictStore.getUsStates();

const needHintMessage = computed(() =>
  ["AK", "HI"].includes(shippingState.value),
);

watch(
  () => shippingState.value,
  (value, prevValue) => {
    if (!prevValue) {
      return;
    }
    estimateStore.estimate.delivery = true;
  },
);
</script>

<style lang="scss" scoped>
.hint-message {
  display: flex;
  justify-self: flex-end;
  font-size: 16px;
  color: red;
  margin-top: 8px;
}
</style>
